// extracted by mini-css-extract-plugin
export default {"root":"IssuesContainer_root__vXUBc","container":"IssuesContainer_container__WkvV9","salesRepCode":"IssuesContainer_salesRepCode__O-TYf"};